export default __webpack_public_path__ + "static/media/quizz.8e441375.svg";